import { useFormik } from 'formik';

export const REINIT_VALUES = { enableReinitialize: false };

export function useForm(schema, initialState, onSubmit, formikOptions) {
  const formik = useFormik({
    validationSchema: schema,
    // initialErrors: initialState,
    initialValues: initialState,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit,
    ...formikOptions,
  });

  const getFieldProps = (key) => ({
    ...formik.getFieldProps(key),
    error: formik.errors && formik.touched[key] && formik.errors[key],
  });

  return { ...formik, getFieldProps };
}
